import { Maybe } from "@biggeo/bg-server-lib/studio";

/**
 * Unwraps a Maybe type value to either the value itself or undefined.
 * This utility function helps handle nullable/optional values in a type-safe way.
 *
 * @template T - The type of the value wrapped in Maybe
 * @param {Maybe<T>} value - The Maybe value to unwrap
 * @returns {T | undefined} The unwrapped value if it exists, undefined otherwise
 */
export const unwrapMaybe = <T>(value: Maybe<T>): T | undefined =>
    value ?? undefined;
